// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.TextCellColorSettings.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * TextCellColorSettings Component
 */

import React, { Component } from 'react';
import { action } from 'mobx';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import InputByDataType from './Izenda.InputByDataType';
import UIConstants from 'logic/data/Izenda.UIConstants';
import localizer from 'share/localization/Izenda.Localizer';
import { MESSAGE } from 'logic/data/Izenda.SettingsByRangeConstants';
import { some, getOr, isNil, isEmpty } from 'lodash/fp';

@observer
export default class TextCellColorSettings extends Component {
  static propTypes = {
    value: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    loadValue: PropTypes.func,
    pointOptionList: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
  };

  static defaultProps = {
    value: {
      dataType: 'text',
      settingValue: {}
    },
    showTextColor: true,
    showCellColor: true,
    pointOptionList: [{}]
  };

  constructor(props) {
    super(props);

    this.state = {
      value: this.props.loadValue ? this.props.loadValue() : this.props.value
    };
  }

  componentWillReceiveProps(nextProps) {
    nextProps.value &&
      this.setState({
        value: nextProps.loadValue ? nextProps.loadValue() : nextProps.value
      });
  }

  renderBtn = btnName => {
    const props = this.props;

    const state = this.state;
    const popupProps = {
      type: 'none',
      autoClose: false,
      sizeClass: 'modal-lg'
    };
    const BTN_INFO = {
      textColor: {
        icon: 'icon-font text-color',
        title: localizer.getText('TEXT_CELL_COLOR_TOOLTIP_TEXT_COLOR')
      },
      cellColor: {
        icon: 'icon-tint text-color',
        title: localizer.getText('TEXT_CELL_COLOR_TOOLTIP_CELL_COLOR')
      }
    };
    const value = props.loadValue ? props.loadValue() : props.value;

    const popupContentProps = $izenda.extend({}, props, {
      dataType: value.dataType,
      dateTimeFormatData: value.dateTimeFormatData,
      settingValue: value.settingValue[btnName],
      colorType: btnName,
      validateMessages: MESSAGE.M02,
      pointOptionList: props.pointOptionList,
      isBubbleContainer: props.isBubbleContainer,
      isGridReport: props.isGridReport,
      valueProps: {
        title: localizer.getText('COLOR_SETTING_TOOLTIP'),
        type: 'color',
        defaultColor: btnName === 'textColor' ? UIConstants.textColor : UIConstants.backgroundColor
      },
      beforeClosing: 'beforeClosing'
    });

    const settingValue = getOr({}, btnName, value.settingValue);
    const hadSetting =
      !isEmpty(settingValue.value) ||
      !isEmpty(settingValue.rangeValue) ||
      !isEmpty(settingValue.rangePercent) ||
      !isEmpty(settingValue.allValues) ||
      some(
        item => !isNil(item) && (!isNil(item.value) || !isNil(item.rangePercent) || !isNil(item.rangeValue) || !isNil(item.allValues)),
        settingValue
      );
    const fnResetDefaultValue = btnName === 'textColor' ? props.fnResetTextDefaultValue : props.fnResetCellDefaultValue;
    return (
      <InputByDataType
        type="btnPopup"
        popupTitle={BTN_INFO[btnName].title}
        popupContent={props.cellComponent}
        containerClassName="text-color"
        className={BTN_INFO[btnName].icon}
        popupProps={popupProps}
        popupContentProps={popupContentProps}
        onChange={onChange.bind(this)}
        hadSetting={hadSetting}
        fnResetDefaultValue={fnResetDefaultValue}
        value={value}
        settingValue={settingValue}
      />
    );

    function onChange(newVal) {
      const newValue = newVal || {};
      const settingValue = state.value.settingValue;
      settingValue[btnName] = newValue.value;
      this.setState(
        { value: state.value },
        action(() => {
          fnResetDefaultValue();
          props.onChange && props.onChange({ value: state.value });
        })
      );
    }
  };

  render() {
    const { className, showTextColor, showCellColor } = this.props;
    const classes = classnames('text-cell-color', className);

    return (
      <div className={classes}>
        {showTextColor && this.renderBtn('textColor')}
        {showCellColor && this.renderBtn('cellColor')}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.TextCellColorSettings.jsx